import { ReactElement } from 'react';
import { Props } from './';
import './WithCount.scss';

export const WithCount = ({ children, count }: Props): ReactElement => (
  <div className="WithCount">
    <div className="WithCount-Label">{children}</div>

    <div className="WithCount-Count">{count}</div>
  </div>
);
